// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","breadcrumbs":"Breadcrumbs__breadcrumbs--HM","separator":"Breadcrumbs__separator--Z9","highlight":"Breadcrumbs__highlight--NT"};